import { FETCH_SURVEY_REQUEST, FETCH_SURVEY_SUCCESS, FETCH_SURVEY_FAILURE, CREATE_SURVEY_REQUEST, CREATE_SURVEY_SUCCESS, CREATE_SURVEY_FAILURE } from "./types";

export const fetchSurveyRequest = (eventId) => ({
    type: FETCH_SURVEY_REQUEST,
    payload: eventId
});

export const fetchSurveySuccess = (data) => ({
    type: FETCH_SURVEY_SUCCESS,
    payload: data
});

export const fetchSurveyFailure = (error) => ({
    type: FETCH_SURVEY_FAILURE,
    payload: error
});
// Action Creator for creating a survey
export const createSurvey = (eventId, surveyData) => {
    return {
        type: CREATE_SURVEY_REQUEST,
        eventId,
        payload: surveyData,
    };
};

export const createSurveyRequest = (payload) => ({
    type: CREATE_SURVEY_REQUEST,
   payload,
});

export const createSurveySuccess = () => ({
    type: CREATE_SURVEY_SUCCESS,
});

export const createSurveyFailure = (error) => ({
    type: CREATE_SURVEY_FAILURE,
    payload: error,
});
